import type { DeviceStatus } from '@/feature/device/types/device';
import { formatDeviceStatus } from '@/feature/device/utils/deviceLabels';

interface IDeviceStatusBadgeProps {
  status: string;
}

const STATUS_CLASSES: Record<DeviceStatus, string> = {
  available: 'bg-emerald-100 text-emerald-800',
  rented: 'bg-blue-100 text-blue-800',
  maintenance: 'bg-amber-100 text-amber-800',
  unfit: 'bg-red-100 text-red-800',
};

const DeviceStatusBadge = ({ status }: IDeviceStatusBadgeProps) => {
  const key = status.toLowerCase() as DeviceStatus;
  const color = STATUS_CLASSES[key] || 'bg-gray-100 text-gray-800';

  return (
    <span
      className={`inline-block px-2 py-0.5 rounded-full font-medium text-center whitespace-nowrap text-sm ${color}`}
      data-status={status.toLowerCase()}
    >
      {formatDeviceStatus(status)}
    </span>
  );
};

export default DeviceStatusBadge;
